export const MetaDataConstants = {
    HOME: {
        TITLE: 'Find Your Perfect Wedding Venue | Wedshed',
        DESCRIPTION: 'Searching for the ideal wedding venue? WedShed connects couples with unique spaces across Australia. Start planning your big day today!',
        OGIMAGEURL: '',
    },
    GET_IN_TOUCH: {
        TITLE: 'Get In Touch | Wedshed',
        DESCRIPTION: 'Get In Touch | Wedshed',
        OGIMAGEURL: '',
    },
    ABOUT_US: {
        TITLE: 'About Wedshed – Your Go-To Wedding Planning Platform',
        DESCRIPTION: 'Wedshed simplifies wedding planning by offering a curated selection of unique venues and trusted vendors. Plan your perfect wedding effortlessly!',
        OGIMAGEURL: '',
    },
    CONTACT_US: {
        TITLE: 'Contact Wedshed for Wedding Planning Solutions',
        DESCRIPTION: 'Have questions or need support with your wedding planning? Connect with the Wedshed team to find the best wedding venues, services, and tips for a stress-free experience.',
        OGIMAGEURL: '',
    },
    HOW_IT_WORKS_COUPLE: {
        TITLE: 'Stress-Free Wedding Planning for Modern Couples | Wedshed',
        DESCRIPTION: 'Find the perfect wedding venue and vendors all in one place. Wedshed makes wedding planning easy, fun, and hassle-free for every couple!',
        OGIMAGEURL: '',
    },
    HOW_IT_WORKS_FAQ: {
        TITLE: 'Wedshed FAQs | Find, Book & Plan Your Dream Wedding Venue',
        DESCRIPTION: 'Discover how Wedshed makes wedding planning effortless. Our FAQs answer all your venue-related questions to help you say.',
        OGIMAGEURL: '',
    },
    HOW_IT_WORKS_VENDOR: {
        TITLE: 'Find the Best Wedding Vendors in Australia | Wedshed',
        DESCRIPTION: 'Discover top-rated wedding vendors in Australia on Wedshed. From photographers to florists, find the perfect team to bring your dream wedding to life.',
        OGIMAGEURL: '',
    },
    HOW_IT_WORKS_VENUE : {
        TITLE: 'How It Works: List & Find Wedding Venues | Wedshed',
        DESCRIPTION: 'Looking to list or book a wedding venue? Wedshed makes it easy for venue owners and couples to connect. Find your dream venue today!',
        OGIMAGEURL: '',
    },
    PLANNING_HUB: {
        TITLE: 'Plan Your Dream Wedding with Wedshed',
        DESCRIPTION: 'From finding the perfect venue to organising the finer details, Wedshed’s Planning Hub is your ultimate guide to stress-free wedding planning.',
        OGIMAGEURL: '',
    },
    VENDOR_LIST: {
        TITLE: 'Find Your Perfect Wedding Vendors | Wedshed',
        DESCRIPTION: 'Discover top wedding vendors in Australia with Wedshed. From venues to photographers, florists, and more—plan your dream wedding effortlessly!',
        OGIMAGEURL: '',
    },
    VENUE_LIST: {
        TITLE: 'Unique & Affordable Wedding Venues | Wedshed',
        DESCRIPTION: 'Searching for the perfect wedding venue? WedShed connects couples with stunning locations across Australia—barns, estates, waterfronts, and more!',
        OGIMAGEURL: '',
    },
    PRIVACY_POLICY: {
        TITLE: 'Privacy Policy | Wedshed',
        DESCRIPTION: 'Privacy Policy | Wedshed',
        OGIMAGEURL: '',
    },
    SEARCH_RESULTS: {
        TITLE: 'Search Results | Wedshed',
        DESCRIPTION: 'Search Results | Wedshed',
        OGIMAGEURL: '',
    },
    SIGN_UP: {
        TITLE: 'Sign Up | Wedshed',
        DESCRIPTION: 'Sign Up | Wedshed',
        OGIMAGEURL: '',
    },
    SUBMIT_REAL_WEDDING: {
        TITLE: 'Submit Your Real Wedding to Wedshed | Wedding Inspiration',
        DESCRIPTION: 'Share your real wedding on Wedshed! Submit your wedding details and inspire couples planning their big day with beautiful, authentic ideas.',
        OGIMAGEURL: '',
    },
    TERMS_AND_CONDITIONS: {
        TITLE: 'Terms and Conditions | Wedshed',
        DESCRIPTION: 'Terms and Conditions | Wedshed',
        OGIMAGEURL: '',
    },
    WEDSPIRATION: {
        TITLE: 'Wedding Planning Advice & Ideas | Wedshed',
        DESCRIPTION: 'Explore expert wedding planning advice, creative ideas, and tips to make your big day unforgettable. Get inspired with Wedshed\'s comprehensive guides for brides and grooms.',
        OGIMAGEURL: '',
    },
};
